<template>
  <BaseNoticeItem
    :button-text="$t('Edit profile now')"
    :button-url="buttonUrl"
    :status="$t('Information missing')"
    data-test="compliance-alert-full-name"
  >
    <template #head>
      <strong>{{ $t('We need your full name') }}</strong>
    </template>
    <template #body>
      {{ $t('Please provide us with your full name before you start working via Worksome.') }}
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const { $t } = useTranslation()

const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(namedRoutes.frontend.user.profile.edit, {
    redirect_uri: redirectUri,
  })
  return `${path}#account-setup`
})
</script>
